import { ReactNode } from "react";
import ExpirationDateApproved from "./ExpirationDateApproved";

interface DetailProps {
	id: string;
	children: ReactNode;
	info?: any;
	checks?: boolean;
}


const Detail: React.FC<DetailProps> = ({ id: key, children, info, checks }) => {

	if (!!children) return <>{children}</>;
	if (!checks && !!!children && typeof info === 'object') return <>{key in info && info[key]}</>;
	return <>
		<img src='/lulav-icons/approved-check.svg' />
		{key.includes('Expiry') && <ExpirationDateApproved expirationDate={info?.section46Expiry} />}
	</>

}

export default Detail;